var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_9","data-name":"Group 9","transform":"translate(-1036 -1929)"},[React.createElement("rect",{"id":"Rectangle_52","data-name":"Rectangle 52","width":"40","height":"40","transform":"translate(1036 1929)","fill":"#fff","opacity":"0","key":0}),React.createElement("path",{"id":"Icon_awesome-facebook-f","data-name":"Icon awesome-facebook-f","d":"M14.414,14.392l.711-4.63H10.682v-3a2.315,2.315,0,0,1,2.61-2.5h2.02V.313A24.631,24.631,0,0,0,11.727,0c-3.659,0-6.05,2.218-6.05,6.232V9.761H1.609v4.63H5.677V25.585h5.006V14.392Z","transform":"translate(1047.124 1936.37)","fill":"#fff","key":1})]));
}

Facebook.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = Facebook;

Facebook.default = Facebook;
